import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

// Import router
import Router from './router';

var data = require('./routes.json');

export default class Routes extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/assets" />
                {data.routes.map((route, key) => {
                    return (
                        <Route
                            key={key}
                            exact
                            path={route.url}
                            render={props => (
                                <Router
                                    {...props}
                                    request={route.request}
                                    title={route.title}
                                    metaDescription={
                                        route.metaDescription
                                            ? route.metaDescription
                                            : 'JD Sports Fashion plc is the leading retailer and distributor of branded sportswear and fashionwear.'
                                    }
                                    metaImage={
                                        route.metaImage
                                            ? route.metaImage
                                            : 'https://files.jdplc.com/images/home/slide1.jpg'
                                    }
                                    shortname={route.shortname}
                                    url={route.url}
                                    nav={route.navlocal}
                                    browser={this.props.browser}
                                />
                            )}
                        />
                    );
                })}
                <Route
                    render={props => (
                        <Router
                            {...props}
                            request="about"
                            title="Page not found"
                            metaDescription="JD Sports Fashion plc is the leading retailer and distributor of branded sportswear and fashionwear."
                            shortname="404"
                        />
                    )}
                />
            </Switch>
        );
    }
}
